/* eslint-disable @typescript-eslint/no-explicit-any */
import { ModuleBase } from './ModuleBase'
import { hall } from '@/hall'
import { base } from '@/base/base'
import { WebDefine } from '@/defines/WebDefine'
import { log, urlAddOrUpdateParams } from '@/utils/functions'

export class ShareModule extends ModuleBase {
  private RETRY_COUNT = 3 //3次重连机会

  private ListMaxSize = 39 //获取多少条数据就要先显示界面，等下次重新点击了
  private ListNum = 13 //每次请求列表数量

  public myrewardInfo: any = null //玩家首页金额奖励
  public rules: any = null //规则
  public referrals: any[] = [] //下级玩家列表
  public referralsMax = 0 //下级玩家列表数量
  public recvReward = 0 //领取奖励金币
  public inviteChest: any = null //分享人数界面
  public VipUpgradeRecord: any = null //分享宝箱界面
  public maxMoney = 0 //分享最多奖励数量
  public maxPeople = 0 //分享最多人数
  public ReferrMoney = 0 //分享最多宝箱奖励数量
  public InviteChestNum = 0

  public canSendReward = true //是否可以请求奖励数据（上一个请求还没返回）
  public canSendRule = true //是否可以请求规则数据（上一个请求还没返回）
  public canSendReferrals = true //是否可以请求下级玩家列表数量数据（上一个请求还没返回）
  public reqListALL = false //--是否可以继续请求下线玩家列表
  init(): void {
    this.setReqList(true)
  }

  onClear(): void {}

  onLoad(): void {
    hall.eventDispatcher.on(hall.EventDefine.Native2Lua, this.onNative2Lua, this)
  }

  onDestroy(): void {
    hall.eventDispatcher.off(hall.EventDefine.Native2Lua, this.onNative2Lua, this)
  }

  inits2c(): void {}

  onPreloadData(): void {
    log('ShareModule onPreloadData')
    this.requestRuleInfos()
    this.checkAdjustAttribution()

    if (sys.isBrowser) {
      // ?uid=101040
      const uidString = localStorage.getItem(hall.DataKeyDefine.Share) //当前在玩的游戏ID
      const topUID = base.app.getUrlSearchParams('uid')
      if (uidString != topUID) {
        this.postShareBind(topUID)
      }
    }
  }

  tryGetRewardInfos_(count: number) {
    log('tryGetRewardInfos_ count =', count)
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.shareGetReward, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.canSendReward = true
          this.myrewardInfo = respJson.data
          hall.eventDispatcher.emit(hall.EventDefine.ShareRewaedChange)
        }
      })
      .catch((error) => {
        log('tryGetRewardInfos_ failFun')
        count = count + 1
        if (count > this.RETRY_COUNT) {
          //--直接初始化界面不显示了
        } else {
          this.tryGetRewardInfos_(count)
        }
      })
  }

  tryGetRuleInfos_(count: number) {
    log('tryGetRuleInfos_ count =', count)
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
      //gid: 28014
    }
    base.httpUtil
      .postJson(WebDefine.shareGetRule, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          log('tryGetRuleInfos_ success', respJson.data.url)
          this.canSendRule = true
          this.rules = respJson.data

          hall.eventDispatcher.emit(hall.EventDefine.ShareRulehange)
        }
      })
      .catch((error) => {
        log('tryGetRuleInfos_ failFun', error.message, error.name)
      })
  }

  tryGetReferralsInfos_(count: number) {
    log('tryGetReferralsInfos_ count =', count)
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
      index: this.referrals.length,
      size: this.ListNum,
    }
    base.httpUtil
      .postJson(WebDefine.shareGetReferrals, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.mergeTables(respJson.data)
          this.referralsMax = respJson.data.total
          //判断当前列表数量是不是超了最多显示（先拿部分展示，然后慢慢加载）
          if (this.reqListALL) {
            if (respJson.data.total <= this.ListMaxSize) {
              if (this.referrals.length == respJson.data.total) {
                //全部请求完毕了
                this.canSendReferrals = true
                hall.eventDispatcher.emit(hall.EventDefine.ShareReferralsChange)
              } else {
                this.tryGetReferralsInfos_(0)
              }
            } else {
              //数量大于闸值，先拿一部分显示，后面继续请求获取
              if (this.referrals.length == this.ListMaxSize) {
                hall.eventDispatcher.emit(hall.EventDefine.ShareReferralsChange)
                if (this.ListMaxSize < respJson.data.total) {
                  //继续请求
                  this.tryGetReferralsInfos_(0)
                }
              } else if (this.referrals.length == respJson.data.total) {
                //全部请求完毕了
                this.canSendReferrals = true
                hall.eventDispatcher.emit(hall.EventDefine.ShareReferralsChangeMax)
              } else {
                //继续请求
                this.tryGetReferralsInfos_(0)
              }
            }
          }
        }
      })
      .catch(() => {
        log('tryGetReferralsInfos_ failFun')
        count = count + 1
        if (count > this.RETRY_COUNT) {
          //--直接初始化界面不显示了
        } else {
          this.tryGetReferralsInfos_(count)
        }
      })
  }

  getRewardInfo() {
    return this.myrewardInfo
  }

  getRuleInfo() {
    return this.rules
  }

  getShareUrl(): string {
    let shareUrl = ''
    if (this.rules) {
      // web 使用 uid
      // android 使用 client_custom_params_1
      if (sys.isBrowser) {
        shareUrl = urlAddOrUpdateParams(this.rules.url, {
          uid: hall.userModule.userId,
        })
      } else {
        shareUrl = urlAddOrUpdateParams(this.rules.url, {
          client_custom_params_1: hall.userModule.userId,
        })
      }
    }

    log(`getShareUrl shareUrl = ${shareUrl}`)
    return shareUrl
  }

  getReferralInfo() {
    return this.referrals
  }

  getReferralMax() {
    return this.referralsMax
  }

  getRecvReward() {
    return this.recvReward
  }

  cleanShareInfo() {
    this.myrewardInfo = null
    this.rules = null
    this.referrals = []
    this.referralsMax = 0
    this.canSendReward = true
    this.canSendRule = true
    this.canSendReferrals = true
    this.setReqList(false)
  }

  //是否可以继续请求下线玩家列表
  setReqList(type: boolean) {
    this.reqListALL = type
  }

  //领取奖励
  tryGetRecvReward() {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.shareGetRecvReward, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.recvReward = respJson.data.gold
          hall.eventDispatcher.emit(hall.EventDefine.ShareRecvReward)
        }
      })
      .catch(() => {
        log('tryGetRecvReward failFun')
      })
  }

  onNative2Lua(tag: any, attribution?: any) {
    log('ShareModule:onNative2Lua tag =', tag)

    // if (tag == NativeBridgeTags.adjustAttributionChanged) {
    //   this.checkAdjustAttribution(attribution)
    // }
  }

  checkAdjustAttribution(attribution?: any) {
    //if(attribution == null )
    //{
    //    let ok, ret = base.nativeUtils.callNative(base.NativeApi.getAdjustAttribution)
    //    if(!ok || ret == null || ret == "")
    //    {
    //        log("ShareModule:checkAdjustAttribution ret is null")
    //        return
    //    }
    //    attribution = json.decode(ret)
    //}
    //let clickLabel = attribution.clickLabel
    //if(clickLabel && clickLabel != "" && typeof clickLabel === 'number')
    //{
    //    if(clickLabel != 0 )
    //    {
    //        this.postShareBind(clickLabel)
    //    }
    //}
  }

  postShareBind(uid: string) {
    if (uid == null || uid == '') {
      log(`postShareBind uid is null`)
      return
    }

    const top_uid = Number(uid)
    if (isNaN(top_uid)) {
      log(`postShareBind top_uid is null`)
      return
    }

    log('postShareBind top_uid =', top_uid)
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
      top_uid: top_uid,
    }
    base.httpUtil
      .postJson(WebDefine.shareBind, data)
      .then((respJson) => {
        log('postShareBind successFun', respJson)
        if (respJson.code == 200) {
          localStorage.setItem(hall.DataKeyDefine.Share, uid)
          log('postShareBind successFun')
        }
      })
      .catch((error) => {
        log('error:postShareBind', error)
      })
  }

  //个人分享信息
  tryInviteChestInfo() {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.ActiveInviteRecord, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.inviteChest = respJson.data
          hall.eventDispatcher.emit(hall.EventDefine.OnInviteChestInfo)
        }
      })
      .catch(() => {
        log('tryGetRecvReward failFun')
      })
  }

  //个人分享信息领取
  tryInviteChestGet(money: number, cycle_id: number, level: number, onSuccess?: () => void) {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
      money: money,
      cycle_id: cycle_id,
      level: level,
    }
    base.httpUtil
      .postJson(WebDefine.ActivelnviteGet, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          hall.eventDispatcher.emit(hall.EventDefine.OnInviteChestGet)
          if (onSuccess) {
            onSuccess()
          }
        }
      })
      .catch(() => {
        log('tryGetRecvReward failFun')
      })
  }

  //分享宝箱数据
  tryReferralBoxInfo() {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.ActiveVipUpgradeRecord, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.VipUpgradeRecord = respJson.data
          hall.eventDispatcher.emit(hall.EventDefine.OnReferralBoxInfo)
        }
      })
      .catch((error) => {
        log('tryGetRecvReward failFun')
      })
  }

  //分享宝箱领取
  tryReferralBoxGet() {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.ActiveVipUpgradeGet, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          hall.eventDispatcher.emit(hall.EventDefine.OnReferralBoxGet)
        }
      })
      .catch((error) => {
        log('tryGetRecvReward failFun')
      })
  }

  // ** ** 会有数据没到连续点击按钮请求数据的情况，直接没有得到回调就继续请求，界面会切换，但是都是初始没有数据的界面
  requestRewardInfos() {
    if (this.canSendReward) {
      this.canSendReward = false
      this.tryGetRewardInfos_(0)
    }
  }

  requestRuleInfos() {
    if (this.canSendRule) {
      this.canSendRule = false
      this.tryGetRuleInfos_(0)
    }
  }

  requestReferralsInfos() {
    if (this.canSendReferrals) {
      this.canSendReferrals = false
      this.tryGetReferralsInfos_(0)
    }
  }

  mergeTables(t2: any) {
    for (let i = 0; i < t2.list.length; i++) {
      this.referrals.push(t2.list[i])
    }
  }

  shareToWhatsApp() {
    //hall.DailyTasksModule.requestDailyListShare()
    //let ok, ret = base.nativeUtils.callNative(base.NativeApi.whatsAppShare, url, content)
    //let IOSPlatform = gt.isIOSPlatform()
    //if(IOSPlatform)
    //{
    //    if(ok)
    //    {
    //        if(ret == "-1")
    //        {
    //            base.toast(hall.Language.ShareModule_whatapp_tip)
    //        }
    //    }
    //}
  }

  shareToFacebook() {
    //每日任务触发分享的请求
    //hall.DailyTasksModule.requestDailyListShare()
    //let ok, ret = base.nativeUtils.callNative(base.NativeApi.facebookShare, url, content)
    //let IOSPlatform = gt.isIOSPlatform()
    //if(IOSPlatform)
    //{
    //    if(ok)
    //    {
    //        if(ret == "-1")
    //        {
    //            base.toast(hall.Language.ShareModule_Facebook_tip)
    //        }
    //    }
    //}
  }

  shareToTelegram() {
    //hall.DailyTasksModule.requestDailyListShare()
    //let finalUrl = "https://t.me/share/url?url=" + string.urlencode(url) + "&text=" + string.urlencode(content)
    //log("ShareModule:shareToTelegram() finalUrl =", finalUrl)
    //cc.Application:getInstance():openURL(finalUrl)
  }
}
